import { useLocale } from "../localization/LocaleProvider";

export default function SearchClients(props) {
    const {searchFilter, setSearchFilter} = props;
    const { translate } = useLocale();
  
    return (
      <div className="search" style={{position: "relative"}}>
        <div style={{position: "absolute", right: 8, width: '20px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          {searchFilter.length > 0 ? <i className="fa fa-times" onClick={() => setSearchFilter("")}></i> : <i className="fa fa-search"></i>  }
        </div>
        <input type="text" placeholder={translate("Search clients by name")} style={{width: "100%"}} value={searchFilter} onChange={(e) => setSearchFilter(e.target.value)} />
      </div>
    )
  }